/*
 * Copyright © Siemens 2026
 */

import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { routes } from './app.routes';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { AuthService } from './core/auth/services/auth.service';
import { ApiConfiguration as publishingApiConfig } from './api/publishing/api-configuration';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(() => inject(AuthService).init()),
    provideOAuthClient({
      resourceServer: {
        // Attach the access token only to requests hitting the publishing-service API
        // (relative "/api/..." proxy URL locally, "/publishing-service/v1" behind
        // CloudFront). angular-oauth2-oidc matches by "startsWith", so the base URL
        // (not just "/api") must be listed or the bearer token is never sent.
        allowedUrls: [environment.publishingBaseUrl],
        sendAccessToken: true
      }
    }),
    {
      provide: publishingApiConfig,
      useFactory: () => {
        const config = new publishingApiConfig();
        config.rootUrl = environment.publishingBaseUrl;
        return config;
      }
    },
  ]
};

